<template>
  <button
    :title="$t('DIALER.RESET_STATE')"
    class="flex size-6 items-center justify-center rounded bg-white/10 hover:bg-white/20"
    @click.stop.prevent="$emit('reset')"
  >
    <icon-base :icon="IconReset" width="12" height="12" view-box="0 0 16 16" />
  </button>
</template>

<script setup lang="ts">
import IconReset from "@/components/icons/IconReset.vue";
import IconBase from "@/components/ui/IconBase.vue";

defineEmits<{
  reset: [];
}>();
</script>
